import Vue from "vue";
import store from '@/store/index';
import workSessionsApi from "@/workSessions/workSessionsApi";
import {
    WSOSResponseNoOpenSessionFound,
    WSVerifyResponseSessionNotFoundOrClosed, WSVerifyResponseSessionValidButExpired,
    WSVerifyResponseValidSession, WSVerifyServerErr404, WSVerifyUnknownServerErr,
} from "@/workSessions/constants";
import {workSessionStorageHelper} from "@/workSessions/helpers/workSessionStorageHelper";

let instance;


/** Returns the current instance of the SDK */
export const getInstance = () => instance;

/** Creates an instance of the WorkSessions plugin. If one has already been created, it returns that instance */
export const useWorkSessions = () => {
    if (instance) return instance;

    // The 'instance' is simply a Vue object
    instance = new Vue({
        data() {
            return {
                loading: false,
                hasError: false,
                lmraLocked: false,
                displayResumeSessionDialog: false,
                displayWorkSessionServiceNADialog : false,
                forceCloseWorkSession: false,
            }
        },
        methods: {
            startLoading() {
                this.loading = true;
                this.displayResumeSessionDialog = false;
            },
            //TODO LOGIC TO DETERMINE IF SESSION DATA SHOULD BE COLLECTED OR VALIDATED!
            //IF USER DOES NOT HAVE A SESSION ASK SERVER FOR THE OPEN SESSION IF AVAILABLE
            //ELSE IF USER HAS A SESSION VERIFY THAT THE STORED SESSION BELONGS TO THE USE! AND IS VALID
            async checkUserHasOpenWorkSession() {
                this.startLoading();
                try {
                    window.console.log('PRECLEAR');
                    await store.dispatch('clearSavedSessionData');
                    let response = await workSessionsApi.checkUserHasOpenWorkSession();
                    if (response.data !== null || response.data !== undefined) {
                        let WSData = response.data;
                        if (this.validateWorkSessionObject(WSData)) {
                            window.console.log('VERIFIED NOW STORE THIS SESSIONDATA');
                            await store.dispatch('saveValidatedAndVerifiedWorkSession', WSData)
                            window.console.log('DISPLAY RESUME SESSION');
                            this.displayResumeSessionDialog = true;
                            this.clearLockAndError();
                        }
                    }
                } catch (error) {
                    if (error.response.status === 404) {
                        if (error.response.data) {
                            if (error.response.data.status) {
                                if (error.response.data.status !== WSOSResponseNoOpenSessionFound) {
                                    window.console.log('COS - 404 - BUT WSOSREsponseNoOpenSessionFound');
                                    await this.handleServerError();
                                }
                            }
                        } else {
                            window.console.log('COS - 404 - BUT NO STUFF');
                            await this.handleServerError();
                        }
                    } else {
                        window.console.log('COS - ERROR NO CODE !!');
                        await this.handleServerError();
                    }
                }
                this.loading = false;
            },
            async verifySavedWorkSessionOnServer($sessionKey) {
                window.console.log('START VERIFY!');
                try {
                    let response = await workSessionsApi.verifyWorkSession($sessionKey);
                    if (response.data !== undefined && response.data !== null) {
                        if (response.data.status !== undefined && response.data.status !== null) {
                            window.console.log('RECEIVED RESPONSE');
                            window.console.log(response);
                            return response.data.status;
                        } else {
                            window.console.log('VSWS - UNKNOWN');
                            return WSVerifyUnknownServerErr;
                        }

                    } else {
                        window.console.log('INVALID RESPONSE DETECTED');
                        window.console.log('VSWS');
                        return WSVerifyUnknownServerErr;
                    }

                } catch (error) {
                    if (error.response.status === 404) {
                        if (error.response.data !== undefined && error.response.data !== null) {
                            if (error.response.data.status !== undefined && error.response.data.status !== null) {
                                return error.response.data.status;
                            }
                        } else {
                            window.console.log('VSWS - code');
                            return WSVerifyServerErr404;
                        }
                    } else {
                        window.console.log('VSWS - BAD-500');
                        return WSVerifyUnknownServerErr;
                    }
                }
            },
            async performSessionCheck() {
                this.startLoading();

                //KILL THE ACTIVE SESSION
                await store.dispatch('clearActiveSession');
                let savedSession = await workSessionStorageHelper.decodeAndGetStoredWorkSessionData();
                window.console.log('PREGET');
                window.console.log(savedSession);
                if (savedSession) {
                    window.console.log('ITEM FOUND IN STORAGE');
                    try {
                        if (this.validateWorkSessionObject(savedSession)) {
                            window.console.log('VALID WORKSESSION OBJECT - LAUNC SERVER REQUEST');
                            let sessionState = await this.verifySavedWorkSessionOnServer(savedSession.session_key);
                            window.console.log(sessionState);
                            switch (sessionState) {
                                //SESSION IS VALID BUT CAN BE EXPIRED (HANDLED IN POPUP)
                                case WSVerifyResponseValidSession:
                                case WSVerifyResponseSessionValidButExpired:
                                    await store.dispatch('storeValidatedAndVerifiedWorkSessionInMemory', savedSession);
                                    this.lmraLocked = false;
                                    this.hasError = false;
                                    this.loading = false;
                                    if (sessionState === WSVerifyResponseSessionValidButExpired) {
                                        this.displayResumeSessionDialog = true;
                                    }
                                    break;
                                case WSVerifyResponseSessionNotFoundOrClosed:
                                    window.console.log('REMOVE THIS SESSION IT IS CLOSED');
                                    window.console.log('WTF ARE U DOING !!!!');
                                    await this.checkUserHasOpenWorkSession();
                                    break;
                                case WSVerifyUnknownServerErr:
                                case WSVerifyServerErr404:
                                    await this.handleServerError()
                                    break;
                            }
                        } else {
                            await this.checkUserHasOpenWorkSession();
                            window.console.log('NOT A VALID OBJECT');
                        }
                    } catch (e) {
                        window.console.log('LAUNCH FETCH NS - CORRUPT DATA !!!')
                        await this.checkUserHasOpenWorkSession();
                    }
                } else {
                    //TODO LAUNCH FETCHIE!!
                    window.console.log('LAUNCH FETCH NEW SESSIE F-E-SESS');
                    await this.checkUserHasOpenWorkSession();
                }

            },
            validateWorkSessionObject($obj) {
                if (
                    (!$obj.eol) ||
                    (!$obj.ttl) ||
                    (!$obj.session_key)
                ) {
                    return false;
                }

                return true;
            },
            async handleServerError($lockLmra = true) {
                window.console.log('SERVER ERROR COULD NOT CHECK OR VALIDATE ERROR LOCK LMRA? : ' + $lockLmra + '}!!!');
                await store.dispatch('clearActiveSession');
                await store.dispatch('clearSavedSessionData');
                if (!this.hasError && !this.lmraLocked) {
                    this.displayWorkSessionServiceNADialog = true;
                    window.console.log('LOCK LMRA NOW...');
                    window.console.log('Notify users');
                } else {
                    window.console.log('ALREADY LOCKED NO ACTION NEEDED')
                }

                this.lmraLocked = $lockLmra;
                this.hasError = true;
                //DO WE KNOW USER .???
                //window.console.log('Do we know user ? :');
                /*let user = await store.getters.getUserId
                window.console.log(user);
                if(user){
                    let savedSession = await workSessionStorageHelper.decodeAndGetStoredWorkSessionData();
                    if(this.validateWorkSessionObject(savedSession)){
                        if(user.email === savedSession.user){
                            window.console.log('SESSION BELONGS TO CURRENT USER');
                        }else{
                            window.console.log('Does not belong to user ...')
                        }
                    }else{
                        //CRITICAL ERROR...
                    }
                }*/


                this.loading = false;
            },
            clearLockAndError() {
                if (this.lmraLocked) {
                    store.commit('launchSnackbarMessage', 'WorksSession Service restored');
                }
                this.lmraLocked = false;
                this.hasError = false;
            }
        },
        computed: {
            hasValidWorkSession() {
                if (!this.loading && store.getters.getActiveWorkSession) {
                    return true
                }
                return false;
            }
        }
    });

    return instance;
}

export const WorkSessionsPlugin = {
    install(Vue) {
        Vue.prototype.$workSessions = useWorkSessions();
    }
}